const EventsTag = ({ content, color }) => {
  if (content)
    return (
      <span
        className={`rounded-[2px] text-btn1 text-white px-[12px] shrink-0 
        py-[5px] trans group-hover:bg-pale7 ${color ? color : "bg-black"}
        `}
      >
        {content}
      </span>
    );

  return <></>;
};

export default EventsTag;
